<template>
  <div>
    <!-- 头部操作 -->
    <el-button-group style="width: 100%; display: inline-block">
      <el-tooltip
        class="uten-tabs"
        effect="dark"
        placement="bottom"
        :content="'添加配置项'"
      >
        <el-button type="primary" size="large" @click="handleScope('', 'add')">
          <el-icon><Plus /></el-icon>添加
        </el-button>
      </el-tooltip>
      <el-tooltip
        class="uten-tabs"
        effect="dark"
        placement="bottom"
        :content="'添加编辑或者删除配置项成功之后需要重新发布才能生效'"
      >
        <el-button
          type="primary"
          size="large"
          @click="handleScope('', 'PublishConfig')"
        >
          <el-icon><Position /></el-icon>发布
        </el-button>
      </el-tooltip>
      <!-- <el-button
        size="large"
        style="float: right; margin-right: 40px"
        @click="handleScope('', 'GoPublishConfig')"
      >
        <el-icon><Right /></el-icon>配置中心后台
      </el-button> -->
    </el-button-group>

    <!-- 表格区域 -->
    <TableList
      id="ConfigServerData"
      :table-height="tableMaxHeight"
      :isShowRefresh="false"
      componentTableId="ConfigServerData"
      :header-data="headerData"
      :table-data="tableData"
      :table-loading="tableLoading"
      :element-loading-text="loadingText"
      @selectChange="selectChange"
    >
      <template #operationCustom="{ scope, index }">
        <div v-if="scope.key !== 'content'">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="handleScope(scope, 'edit')"
            >编辑</el-button
          >
          <el-button
            type="danger"
            plain
            v-if="isDelect"
            size="mini"
            @click="handleScope(scope, 'delete')"
            >删除</el-button
          >
        </div>
        <span v-else>限技术操作</span>
      </template>
    </TableList>
    <!-- 添加编辑 -->
    <el-dialog
      :title="ConfigServer"
      v-model="dialogVisibleStduent"
      width="850px"
      custom-class="publicDialog"
      :close-on-click-modal="false"
      style="padding-top: 10px"
      :before-close="beforeClose"
      draggable
                destroy-on-close
    >
      <div class="abow_dialog">
        <AddConfigServerData
          v-if="dialogVisibleStduent"
          ref="AddConfigServerData"
          :namespaceName="namespaceName"
          :EditInfo="configServerInfo"
          :isEdit="isEdit"
          @update-list="updataList1"
          @close-dialog="closeDialog"
        ></AddConfigServerData>
      </div>
    </el-dialog>
    <!-- 添加编辑富文本 -->
    <el-dialog
      :title="ConfigServer"
      v-model="dialogVisibleEditor"
      width="850px"
      :close-on-click-modal="false"
      custom-class="publicDialog"
      style="padding-top: 10px"
      :before-close="beforeClose"
      draggable
                destroy-on-close
    >
      <div class="abow_dialog">
        <AddConfigServerEditorData
          v-if="dialogVisibleEditor"
          ref="AddConfigServerEditorData"
          :namespaceName="namespaceName"
          :EditInfo="configServerInfo"
          :isEdit="isEdit"
          @update-list="updataList1"
          @close-dialog="closeDialog"
        ></AddConfigServerEditorData>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TableList from "components/TableList.vue";
import AddConfigServerData from "./AddConfigServerData.vue";
import AddConfigServerEditorData from "./AddConfigServerEditorData.vue";
import { DeleteConfig, PublishConfig } from "../../network/configServer";
import { isNull } from "../../common/utils";
import { ref, reactive, toRefs, watch, onMounted,h,computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import store from "../../store/index";
export default {
  name: "ConfigServerData",
  components: {
    TableList,
    AddConfigServerData,
    AddConfigServerEditorData,
  },
  props: {
    tableMaxHeight: Number,
    datas: {
      type: Array,
      default: () => [],
    },
    namespaceName: {
      type: String,
      default: "",
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      ConfigServer: "",
      remarkTitle: "备注信息",
      TrackTitle: "跟踪记录",
      tipText: "",
      headerData: [
        {
          label: "配置项描述备注",
          prop: "comment",
          width: "500",
          align: "left",
          noSetText: "未设置",
          fixed: "left",
        },
        {
          label: "Key(配置项名称)",
          prop: "key",
          width: "240",
          align: "left",
          noSetText: "未设置",
        },
        {
          label: "Value(配置项值)",
          prop: "value",
          minwidth:"300px",
          align: "left",
        },
        {
          label: "管理操作",
          prop: "operation",
          width: "200",
          align: "center",
         operation: true,
         fixed: "right",
          edit: true,
          delete: true,
          custom: true,
        },
       
      ],
      isEdit: false,
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      studentInfo: {
        KeyWord: "",
        Name: "",
        Tel: "",
        QqNumber: "",
        Grade: null,
        StudentIntent: null,
        TrackStartTime: "",
        TrackEndTime: "",
        SignUpStartTime: "",
        SignUpEndTime: "",
        CreateStartTime: "",
        CreateEndTime: "",
        SignUpState: [],
        Source: [],
        GraduatedSchool: "",
        GraduatedMajor: "",
        ApplySchool: "",
        OrderObject: null,
        OrderByAsc: null,
        ApplyMajor: "",
        StudentState: [],
        pageIndex: 1,
        pageSize: 20,
      },
      columnHideList: [],
      // 表格是否在加载中
      tableLoading: false,
      loadingText: "loading...", //加载状态提示文本
      dialogVisibleStduent: false,
      dialogVisibleEditor: false,
      configServerInfo: null,
      newImgUrl: [],
      oldImgUrl: [],
      isDelete: false, //删除图片控制
    });

    // 监听表格数据变化
    watch(
      () => props.datas,
      (newVal) => {
        data.tableData = newVal;
      },
      {
        deep: true,
        immediate: true,
      }
    );
    onMounted(() => {
      
      data.tableData = props.datas;
    });
    const AddConfigServerData = ref();
    const AddConfigServerEditorData = ref();
    const beforeClose = () => {
      data.dialogVisibleStduent = false;
      if (AddConfigServerData.value) {
        AddConfigServerData.value.onCancel();
      }
      data.dialogVisibleEditor = false;
      if (AddConfigServerEditorData.value) {
        AddConfigServerEditorData.value.onCancel();
      }
    };
    const closeDialog = () => {
      data.dialogVisibleStduent = false;
      data.dialogVisibleEditor = false;
    };

    // 格式化学生状态属性名
    const converInfo = (obj) => {
      let aaa = JSON.stringify(obj).replace(/state/g, "studentState");
      return JSON.parse(aaa.replace(/studentStateName/g, "studentStateStr"));
    };
    const clickShengxu = () => {
      data.studentInfo.OrderByAsc = !data.studentInfo.OrderByAsc;
      getData();
    };
    const updataList = (val) => {
      emit("update-list");
    };
    // 表单提交之后保存图片路径
    const updataList1 = (newImgUrl, oldImgUrl) => {
      if (data.newImgUrl.length > 0) {
        if (
          !isNull(newImgUrl) &&
          Object.prototype.toString.call(newImgUrl) == ["[object Array]"]
        ) {
          newImgUrl.map((item) => {
            if (data.newImgUrl.indexOf(item) == -1) {
              data.newImgUrl.push(item);
            }
          });
        } else if (
          !isNull(newImgUrl) &&
          Object.prototype.toString.call(newImgUrl) == ["[object String]"]
        ) {
          if (data.newImgUrl.indexOf(newImgUrl) == -1) {
            data.newImgUrl.push(newImgUrl);
          }
        }
      } else {
        if (
          !isNull(newImgUrl) &&
          Object.prototype.toString.call(newImgUrl) == ["[object Array]"]
        ) {
          data.newImgUrl = [...newImgUrl];
        } else if (
          !isNull(newImgUrl) &&
          Object.prototype.toString.call(newImgUrl) == ["[object String]"]
        ) {
          data.newImgUrl.push(newImgUrl);
        }
      }
      if (data.oldImgUrl.length > 0) {
        if (
          !isNull(oldImgUrl) &&
          Object.prototype.toString.call(oldImgUrl) == ["[object Array]"]
        ) {
          oldImgUrl.map((item) => {
            if (data.oldImgUrl.indexOf(item) == -1) {
              data.oldImgUrl.push(item);
            }
          });
        } else if (
          !isNull(oldImgUrl) &&
          Object.prototype.toString.call(oldImgUrl) == ["[object String]"]
        ) {
          if (data.oldImgUrl.indexOf(oldImgUrl) == -1) {
            data.oldImgUrl.push(oldImgUrl);
          }
        }
      } else {
        if (
          !isNull(oldImgUrl) &&
          Object.prototype.toString.call(oldImgUrl) == ["[object Array]"]
        ) {
          data.oldImgUrl = [...oldImgUrl];
        } else if (
          !isNull(oldImgUrl) &&
          Object.prototype.toString.call(oldImgUrl) == ["[object String]"]
        ) {
          data.oldImgUrl.push(oldImgUrl);
        }
      }
      updataList();
    };
    const store = useStore();
    // 添加编辑弹框
    const handleScope = (row, state) => {
      if (state == "edit") {
        data.ConfigServer = "编辑配置项";
        data.configServerInfo = row;
        data.isEdit = true;
        if (row.key == "GroupNoticeContent") {
          data.dialogVisibleEditor = true;
        } else {
          data.dialogVisibleStduent = true;
        }
      }
      if (state == "add") {
        data.ConfigServer = "添加配置项";
        data.isEdit = false;
        data.configServerInfo = null;
        data.dialogVisibleStduent = true;
      }

      if (state == "delete") {
        deleteConfigServer(row);
      }
      if (state == "PublishConfig") {
        // ElMessageBox.confirm(
        //   `发布成功之后新增的配置会生效，确定发布吗？`,
        //   "确认发布",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning",
        //   }
        // )
        //   .then(() => {
        //     clickPublishConfig();
        //   })
        //   .catch(() => {});
        ElMessageBox({
        title: "确认发布",
        message: "发布成功之后新增的配置会生效，确定发布吗？",
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "确认中",
            // 删除接口
            PublishConfig(props.namespaceName)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                
                ElMessageBox.alert(result.message,"发布", {
                  confirmButtonText: "确认",
                });
                updataList();
              } else {
                done();
                ElMessageBox.alert(result.message,"发布", {
                  confirmButtonText: "确认",
                });
              }
            })
            .catch((err) => {
              done();
              ElMessageBox.alert(result.message,"发布", {
                confirmButtonText: "确认",
              });
            })
          } else {
            done();
          }
        },
      })
      .catch(() => {
        ElMessage("取消发布");
      });
      }
      if (state == "GoPublishConfig") {
        //配置中心
        if (store.state.allConfig) {
          var url = store.state.allConfig.apolloAddress;
          window.open(url, "_blank");
        } else if (sessionStorage.getItem("allConfig")) {
          var url = JSON.parse(
            sessionStorage.getItem("allConfig")
          ).apolloAddress;
          window.open(url, "_blank");
        } else {
          var url = "";
        }
      }
    };
    // 点击发布
    const clickPublishConfig = () => {
      deleteImg();
      PublishConfig(props.namespaceName).then((res) => {
        if (res.code == 0) {
          ElMessageBox.alert(res.message,"发布", {
            confirmButtonText: "确认",
          });
        } else {
          updataList();
          ElMessageBox.alert(res.message,"发布", {
            confirmButtonText: "确认",
          });
        }
      });
    };
    // 删除多余图片
    const deleteImg = () => {
      var deleteImgUrl = JSON.parse(JSON.stringify(data.oldImgUrl));
      if (data.newImgUrl.length > 0 && data.oldImgUrl.length > 0) {
        data.newImgUrl.map((item) => {
          deleteImgUrl = deleteImgUrl.filter((url) => url != item);
        });
        deleteImgUrl = deleteImgUrl.filter((item) => item);
        deleteFile(deleteImgUrl);
      }
    };

    // 删除文件
    const deleteFile = (url) => {
      // 防止多次请求
      data.isDelete = true;
      deleteFile(url)
        .then((res) => {
          data.isDelete = false;
          if (res.code == 0) {
            ElMessageBox.alert(res.message, "提示", {
              confirmButtonText: "确认",
            });
            return false;
          }
          data.newImgUrl = [];
          data.oldImgUrl = [];
        })
        .catch((err) => {
          ElMessageBox.alert("删除文件失败", {
            confirmButtonText: "确认",
          });
        });
    };
    // 删除
    const deleteConfigServer = (val) => {
      var obj = {
        namespaceName: props.namespaceName,
        key: val.key,
      };
          ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "确定要删除所选的配置项【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${val.key}`
          ),
          h("span", null, "】吗？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "确认中",
            
            // 删除接口
            DeleteConfig(obj)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessageBox.alert("删除成功，需要点击发布才能生效", {
                  confirmButtonText: "确认",
                });
                updataList();
              } else {
                done();
                ElMessageBox.alert(res.message, {
                  confirmButtonText: "确认",
                });
              }
            })
            .catch((err) => {
              done();
              ElMessageBox.alert(res.message, {
                confirmButtonText: "确认",
              });
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteDataFunc(val);
        // })
        .catch(() => {});
    };
    const deleteDataFunc = (val) => {
      var obj = {
        namespaceName: props.namespaceName,
        key: val.key,
      };
      DeleteConfig(obj).then((res) => {
        if (res && res.code == 0) {
          ElMessageBox.alert(res.message, {
            confirmButtonText: "确认",
          });
          return;
        }
        ElMessageBox.alert("删除成功，需要点击发布才能生效", {
          confirmButtonText: "确认",
        });
        updataList();
      });
    };
    // 选中
    const selectChange = (val) => {
      data.handleSelection = val;
      if (val.length > 0) {
        data.selectStudentName =
          val[0].name != null
            ? "[" + val[0].name + "]" + "-学习中心"
            : "[学员]-学习中心";
      }
    };
    return {
      AddConfigServerData,
      AddConfigServerEditorData,
      ...toRefs(data),
      beforeClose,
      closeDialog,
      converInfo,
      clickShengxu,
      updataList,
      updataList1,
      handleScope,
      clickPublishConfig,
      deleteImg,
      deleteFile,
      deleteConfigServer,
      deleteDataFunc,
      selectChange,
    };
  },
};
</script>

<style scoped>
::v-deep .publicDialog .el-dialog__body{
padding:30px 0 0 0;
}

</style>
